import { ASC_SORT_ORDER, DESC_SORT_ORDER } from '../constants/sortOrders'

const sortArrow = '↕'
const sortArrowASC = '↑'
const sortArrowDESC = '↓'

const getSortSymbol = (sortOrder) => {
    if (sortOrder === ASC_SORT_ORDER) {
        return sortArrowASC
    }

    if (sortOrder === DESC_SORT_ORDER) {
        return sortArrowDESC
    }

    return sortArrow
}

export default getSortSymbol
